module.exports = __webpack_public_path__ + "r-v3/img/ico_toast_error.6c40f27d.svg";